import { render } from "./MultiUserDisplay.vue?vue&type=template&id=571ecdeb&scoped=true"
import script from "./MultiUserDisplay.vue?vue&type=script&lang=js"
export * from "./MultiUserDisplay.vue?vue&type=script&lang=js"

import "./MultiUserDisplay.vue?vue&type=style&index=0&id=571ecdeb&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571ecdeb"]])

export default __exports__